import { loadBrand } from "chameleonjs";
import { BrandData } from "../brand-context/BrandData";

export function fetchBrandAndSetJigsawHost(brand: string): Promise<BrandData> {
  return loadBrand(brand, "crane").then((brandData: BrandData) => {
    if (brandData.jigsawHost) {
      window.Jigsaw.host = brandData.jigsawHost;
    }
    return brandData;
  });
}
